<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11B3FPR/tc-custom/9781514005231.jpg?1696374742086" alt="This image is the cover for the book Worship by Faith Alone, Dynamics of Christian Worship"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Worship by Faith Alone, Dynamics of Christian Worship
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>In every age, the church must consider what it means to gather together to worship God.</strong> </p> <p>If the church is primarily the people who follow the risen Christ, then its worship should be "gospel-centered." But where might the church find an example of such worship for today?</p> <p>In this Dynamics of Christian Worship volume, scholar, worship leader, and songwriter Zac Hicks contends that such a focus can be found in the theology of worship presented by Thomas Cranmer, the Archbishop of Canterbury during the English Reformation. Hicks argues that Cranmer's reformation of the church's worship and liturgy was shaped primarily by the Protestant principle of justification by faith alone as reflected in his 1552 edition of the <em>Book of Common Prayer</em>, which was later codified under Elizabeth I and has guided Anglican worship for centuries.</p> <p>Here, we find a model of "gospel-centered" worship through which the church of today might be reformed yet again.</p> <p>The Dynamics of Christian Worship series draws from a wide range of worshiping contexts and denominational backgrounds to unpack the many dynamics of Christian worship—including prayer, reading the Bible, preaching, baptism, the Lord's Supper, music, visual art, architecture, and more—to deepen both the theology and practice of Christian worship for the life of the church.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zac Hicks, Ashley Null
      </h2>
      
      <p class="authorDescription body article"><p>Zac Hicks (DMin, Knox Theological Seminary) is adjunct lecturer in music and worship at Samford University, and author of <em>The Worship Pastor: A Call to Ministry for Worship Leaders and Teams</em>. Previously, he served as the Canon for Worship and Liturgy at Advent Cathedral. He lives with his wife, Abby, and their four children in Birmingham, Alabama.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Intervarsity Christian
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fc169f7